<template>
  <div>
    <v-toolbar
      flat
      color="transparent"
    >
      <v-toolbar-title>{{ resource.namePlural }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="חיפוש"
        class="mr-3 ml-3"
      ></v-text-field>

      <!-- <v-spacer></v-spacer> -->
      <v-btn
        color="secondary"
        @click="create"
      >
        <v-icon>add</v-icon> {{ resource.name }}
      </v-btn>
    </v-toolbar>
    <v-data-table
      :loading="fetching"
      :search="search"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="[{'text': 'הכל', 'value': -1}]"
      must-sort
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td
          v-for="(header, index) in headers"
          v-if="index < headers.length - 2"
          v-html="displayValue(props.item, header, index)"
        />
        <td>
          <div
          >
            <v-btn
              small
              icon
              flat
              class="mt-2 ml-0 mr-0"
              :loading="removing[props.item._id]"
              @click="edit({ entityId: props.item._id })"
            >
              <v-icon small>
                edit
              </v-icon>
            </v-btn>
          </div>
        </td>
        <td class="">
          <div
          >
            <v-btn
              small
              icon
              flat
              class="mt-2 ml-0 mr-0"
              :loading="removing[props.item._id]"
              @click="remove(props.item._id)"
            >
              <v-icon small>
                delete
              </v-icon>
            </v-btn>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import generateId from "@/idGenerator";

export default {
  data() {
    return {
      fetching: false,
      search: "",
      removing: {},
      pagination: {}
    };
  },

  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    headers() {
      let headers = [];
      let model = this.resource.model;
      for (let key of Object.keys(model)) {
        headers.push({
          text: model[key].name,
          value: key,
          align: "right"
        });
      }

      headers.push({
        text: "עריכה",
        value: "edit",
        sortable: false,
        width: "100px"
      });

      headers.push({
        text: "מחיקה",
        value: "delete",
        sortable: false,
        width: "100px"
      });
      return headers;
    },
    items() {
      return this.$store.getters["entityList"](this.resource.entityType).map(
        item => {
          let updatedItem = Object.assign({}, item);
          for (let k of Object.keys(item)) {
            let model = this.resource.model[k];
            if (model && model.type === "SELECT") {
              if(Array.isArray(item[k])) {
                updatedItem[k] = item[k].map(x => {
                  if (x._id) x = x._id;
                  if (this.$store.state.entities[model.items]) {
                    if (this.$store.state.entities[model.items][x]) {
                      if (
                        this.$store.state.entities[model.items][x][model.itemText]
                      ) {
                        return this.$store.state.entities[model.items][x][
                          model.itemText
                        ];
                      }
                    }
                  }
                  return x;
                });
              }
            }
          }
          return updatedItem;
        }
      );
    }
  },

  methods: {
    create() {
      let newEntity = { _id: generateId() };
      this.edit({ entity: newEntity, isNew: true });
    },
    edit({ entity, entityId, isNew = false }) {
      if (!entity) {
        entity = this.$store.state.entities[this.resource.entityType][entityId];
      }
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: this.resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    remove(id) {
      this.$confirm("האם למחוק " + this.resource.name).then(res => {
        if (!res) {
          return;
        }
        this.removeConfirmed(id);
      });
    },
    removeConfirmed(id) {
      this.removing[id] = true;
      this.$store
        .dispatch("REMOVE_ENTITY", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          id
        })
        .then(() => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: this.resource.name + " נמחק/ה",
            color: "success"
          });
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.removing[id] = false;
        });
    },
    displayValue(item, header, index) {
      let model = Object.values(this.resource.model)[index];
      let type = model.type;
      if (type === "COLOR") {
        return `<span class="${item[header.value]}--text">${
          item[header.value]
        }</span>`;
      } else if (type === "SELECT") {
        let id = header.value ? header.value._id || header.value : null; 
        if (!id || !item[id]) return "";
        if (!Array.isArray(item[id])) {
          let temp = this.$store.state.entities[model.items][item[id]];
          return temp ? temp[model.itemText] : ''; 
        };
        if (!item[id].length) return "";
        return item[id].reduce((p, v) => p + ", " + v);
      } else if (type === "ICON") {
        return item[header.value];
      } else if (type === "IMAGE") {
        return `<img src="${item[header.value]}" height="30px" />`;
      } else {
        return item[header.value];
      }
    }
  },

  props: ["resource"],

  components: {},

  mounted() {},

  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DataTable.vue